import {AfterContentInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractBaseDetailsComponent} from "../../core/component/abstract-base-details-component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CommonSelectListService} from "../service/common-select-list.service";
import {ToastrService} from "ngx-toastr";
import {CustomParametersDetailsModel} from "./model/custom-parameters-details-model";
import {CustomParameterModel} from "../../modules/custom-parameters/models/custom-parameter.model";
import {bomModuleParamConfigModel} from "../../modules/bom/models/bom-module-param-config-model";
import {ModuleParamGlobConfigService} from "../../core/service/moduleFieldConfig/module-param-glob-config.service";

@Component({
  selector: 'app-custom-param-detail',
  templateUrl: './custom-param-detail.component.html',
  styleUrls: ['./custom-param-detail.component.css']
})
export class CustomParamDetailComponent extends AbstractBaseDetailsComponent implements OnInit , AfterContentInit{

  private readonly MODULE_PARAM_CONFIG_KEY : string = "bomQualityParametersDetails";

  public submitted: boolean = false;
  public detailFormGroup: FormGroup;
  public customParamList: Array<CustomParameterModel>;
  public currentType: string = '';
  public listItems: Array<string>;
  public selectedDefaultValue: string;
  public moduleParams: bomModuleParamConfigModel;

  @Input()
  data: CustomParametersDetailsModel;

  @Output("onSave")
  public saveCallback : EventEmitter<CustomParametersDetailsModel> = new EventEmitter<CustomParametersDetailsModel>();

  @Output("onCancel")
  public cancelCallback : EventEmitter<CustomParametersDetailsModel> = new EventEmitter<CustomParametersDetailsModel>();

  constructor(
    private formBuilder: FormBuilder,
    public commonList: CommonSelectListService,
    public toaster: ToastrService,
    private moduleParamConfigGlob : ModuleParamGlobConfigService,
    private moduleParamConfigGlobService : ModuleParamGlobConfigService,
  ) {
    super(toaster);
  }

  ngOnInit() {
    this.getCustomParams();
    this.setValidation();
    if(this.data && this.data.customParam) {
      this.setType();
      if(this.currentType === 'boolean') {
        this.selectedDefaultValue = this.data.defaultValue;
        this.data.defaultValue = undefined;
      }
      if(this.currentType === 'list') {
        this.prepareDefaultList();
        if(this.data.defaultValue !== undefined) {
          this.selectedDefaultValue = this.data.defaultValue;
          this.data.defaultValue = undefined;
        }
      }
    }
  }

  get f() { return this.detailFormGroup.controls; }

  setValidation() {
    this.detailFormGroup = this.formBuilder.group({
      customParam: ['', (this.moduleParamConfigGlobService.isRequired(this.MODULE_PARAM_CONFIG_KEY,"parameter"))?Validators.required:''],
      type: [{value: '', disabled: true}],
      defaultValue: [''],
      defaultList: [''],
      listValue: [''],
      value1: ['' , (this.moduleParamConfigGlobService.isRequired(this.MODULE_PARAM_CONFIG_KEY,"range_starts"))?Validators.required:''],
      value2: ['' , (this.moduleParamConfigGlobService.isRequired(this.MODULE_PARAM_CONFIG_KEY,"range_ends"))?Validators.required:''],
      tolerance: ['' , (this.moduleParamConfigGlobService.isRequired(this.MODULE_PARAM_CONFIG_KEY,"tolerance"))?Validators.required:'']
    })
  }

  getCustomParams() {
    this.commonList.getCustomParams().subscribe((res) => {
      this.validateResponse(res, () => {
        this.customParamList = new Array<CustomParameterModel>();
        this.customParamList = res.dataList.filter(x => x.active);
      })
    })
  }

  setType() {
    this.resetValidity();
    if(this.data.customParam) {
      this.currentType = this.data.customParam.type.keyName.toLowerCase();

      if(this.data.customParam.type.id === 1 && this.data.customParam.type.keyName.toLowerCase() === 'min') {
        this.detailFormGroup.get('defaultValue').setValidators([this.numberOnlyValidation]);
        this.detailFormGroup.get('defaultValue').updateValueAndValidity();
        this.detailFormGroup.get('tolerance').setValidators([this.numberOnlyValidation]);
        this.detailFormGroup.get('tolerance').updateValueAndValidity();

      }else if(this.data.customParam.type.id === 2 && this.data.customParam.type.keyName.toLowerCase() === 'max') {


        this.detailFormGroup.get('defaultValue').setValidators([this.numberOnlyValidation]);
        this.detailFormGroup.get('defaultValue').updateValueAndValidity();
        this.detailFormGroup.get('tolerance').setValidators([this.numberOnlyValidation]);
        this.detailFormGroup.get('tolerance').updateValueAndValidity();

      }else if(this.data.customParam.type.id === 3 && this.data.customParam.type.keyName.toLowerCase() === 'range') {

        this.detailFormGroup.get('value1').setValidators([this.numberOnlyValidation]);
        this.detailFormGroup.get('value1').updateValueAndValidity();
        this.detailFormGroup.get('value2').setValidators([this.numberOnlyValidation]);
        this.detailFormGroup.get('value2').updateValueAndValidity();
        this.detailFormGroup.get('tolerance').setValidators([this.numberOnlyValidation]);
        this.detailFormGroup.get('tolerance').updateValueAndValidity();

      }else if(this.data.customParam.type.id === 4 && this.data.customParam.type.keyName.toLowerCase() === 'boolean') {

        this.setDefaultList();

      }else if(this.data.customParam.type.id === 5 && this.data.customParam.type.keyName.toLowerCase() === 'list') {

        this.prepareDefaultList();

      }else if(this.data.customParam.type.id === 6 && this.data.customParam.type.keyName.toLowerCase() === 'exact value') {

        this.detailFormGroup.get('defaultValue').setValidators([this.numberOnlyValidation]);
        this.detailFormGroup.get('defaultValue').updateValueAndValidity();
        this.detailFormGroup.get('tolerance').setValidators([this.numberOnlyValidation]);
        this.detailFormGroup.get('tolerance').updateValueAndValidity();

      }else {
        this.resetValidity();
        return;
      }
    }else {
      this.resetData();
    }
  }

  resetData() {
    this.currentType = undefined;
    this.selectedDefaultValue = undefined;
    this.data.defaultValue = undefined;
    this.data.tolerance = undefined;
    this.data.value1 = undefined;
    this.data.value2 = undefined;
  }

  resetValidity() {
    this.detailFormGroup.get('defaultValue').setValidators([]);
    this.detailFormGroup.get('defaultValue').updateValueAndValidity();
    this.detailFormGroup.get('defaultList').setValidators([]);
    this.detailFormGroup.get('defaultList').updateValueAndValidity();
    this.detailFormGroup.get('tolerance').setValidators([]);
    this.detailFormGroup.get('tolerance').updateValueAndValidity();
    this.detailFormGroup.get('listValue').setValidators([]);
    this.detailFormGroup.get('listValue').updateValueAndValidity();
    this.detailFormGroup.get('value1').setValidators([]);
    this.detailFormGroup.get('value1').updateValueAndValidity();
    this.detailFormGroup.get('value2').setValidators([]);
    this.detailFormGroup.get('value2').updateValueAndValidity();
  }

  prepareDefaultList() {
    this.listItems = new Array<string>();
    if(this.data && this.data.customParam && this.data.customParam.listValue) {
      const list: Array<string> = this.data.customParam.listValue.split(',');
      if(list) {
        list.forEach((item) => {
          if(item.length > 0) {
            this.listItems.push(item.trim());
          }
        });
      }
    }
  }

  setDefaultList() {
    if(this.currentType === 'boolean') {
      this.listItems = new Array<string>();
      this.listItems.push('YES');
      this.listItems.push('NO');
    }
  }

  getPlaceholderDefault() {
    let placeholder: string;
    switch (this.currentType) {
      case 'min': placeholder = 'Enter Minimum Value';break;
      case 'max': placeholder = 'Enter Maximum Value';break;
      case 'exact': placeholder =  'Enter Default Value';break;
      case 'list': placeholder = 'Select Default Value';break;
      default: placeholder = 'Enter Default Value';
    }
    return placeholder;
  }

  onSubmit() {
    this.submitted = true;
    if(this.detailFormGroup.invalid) {
      return;
    }
    if(this.data &&
      this.data.customParam &&
      (this.data.customParam.type.keyName.toLowerCase() === 'list' ||
      this.data.customParam.type.keyName.toLowerCase() === 'boolean')) {
      this.data.defaultValue = this.selectedDefaultValue ? this.selectedDefaultValue : undefined;
    }
    this.saveCallback.emit(this.data);
  }

  onCancel() {
    this.cancelCallback.emit(this.data);
  }

  getTypeName() {
    if(this.data && this.data.customParam) {
      if(this.data.customParam.type.keyName.toLowerCase() === 'min') {
        return 'Minimum';
      }
      if(this.data.customParam.type.keyName.toLowerCase() === 'max') {
        return 'Maximum';
      }
      if(this.data.customParam.type.keyName.toLowerCase() === 'range') {
        return 'Range';
      }
      if(this.data.customParam.type.keyName.toLowerCase() === 'exact value') {
        return 'Exact Value';
      }
      if(this.data.customParam.type.keyName.toLowerCase() === 'boolean') {
        return 'Boolean';
      }
      if(this.data.customParam.type.keyName.toLowerCase() === 'list') {
        return 'List';
      }
    }
    return '';
  }

  ngAfterContentInit() {
    this.moduleParams = new bomModuleParamConfigModel(this.moduleParamConfigGlob);
  }

}
